import React from 'react';
import PopoverBase from '@material-ui/core/Popover';

const Popover = (props) => <PopoverBase {...props} />;

export default Popover;
